import React from 'react';
import { DIRECTION_OPTIONS } from '../utils/referralDirection';

// Tiny segmented control for picking inbound / outbound / either.
// Reuses .table-view-segmented styling from CustomerData.css so it
// looks identical to the existing "Sent / Received / Total" picker
// in the Studies metric, which keeps the analysis pages visually
// consistent without bringing in new CSS.
function DirectionToggle({ value, onChange, disabled = false }) {
  return (
    <div className="table-view-segmented" role="group" aria-label="Direction filter">
      {DIRECTION_OPTIONS.map(opt => (
        <button
          key={opt.value}
          type="button"
          className={`table-view-btn ${value === opt.value ? 'active' : ''}`}
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          disabled={disabled}
          title={opt.description}
        >
          {opt.short}
        </button>
      ))}
    </div>
  );
}

export default DirectionToggle;
